// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"209":"e5e47b65","880":"1ccbb6f1"}[chunkId] + ".chunk.js";
};